<template>
  <b-modal
    id="upload-contract-modal"
    ref="uploadModal"
    v-model="isVisible"
    title="Upload ảnh hợp đồng"
    size="xl"
    centered
    @hidden="handleModalHidden"
    @shown="handleModalShown"
  >
    <div class="upload-contract-content">
      <!-- Ảnh Merchant -->
      <div class="upload-section">
        <UploadMultipleCSKH
          ref="merchantUpload"
          :title="'Ảnh Merchant (ĐKKD, ảnh khác)'"
          titleTag="h5"
          titleClass="section-title"
          :accept="'image/jpeg, image/png'"
          :maxFile="200"
          :maxImageFileSize="20"
          :uniqueKey="'merchant'"
          fileType="image"
          @change="handleFileChange('merchant', $event)"
        />
      </div>

      <!-- Ảnh CCCD -->
      <div class="upload-section">
        <UploadMultipleCSKH
          ref="cccdUpload"
          :title="'Ảnh CCCD'"
          titleTag="h5"
          titleClass="section-title"
          :accept="'image/jpeg, image/png'"
          :maxFile="20"
          :maxImageFileSize="20"
          :uniqueKey="'cccd'"
          fileType="image"
          @change="handleFileChange('cccd', $event)"
        />
      </div>

      <!-- File hợp đồng PDF -->
      <div class="upload-section">
        <UploadMultipleCSKH
          ref="pdfUpload"
          :title="'File hợp đồng (PDF)'"
          titleTag="h5"
          titleClass="section-title"
          :accept="'application/pdf'"
          :maxFile="20"
          :maxFileSize="50"
          :uniqueKey="'pdf'"
          fileType="file"
          @change="handleFileChange('pdf', $event)"
        />
      </div>

      <!-- Ảnh hợp đồng -->
      <!-- <div class="upload-section">
        <UploadMultipleCSKH ref="contractUpload" :title="'Ảnh hợp đồng'" titleTag="h5" titleClass="section-title"
          :accept="'image/jpeg, image/png'" :maxFile="20" :maxImageFileSize="20" :uniqueKey="'contract'"
          fileType="image" @change="handleFileChange('contract', $event)" />
      </div> -->
    </div>

    <!-- Custom footer -->
    <template #modal-footer>
      <div class="d-flex justify-content-end align-items-center w-100">
        <b-button
          variant="outline-dark"
          class="mr-2"
          :disabled="loadingSync"
          @click="syncFromRequest"
        >
          <b-spinner v-if="loadingSync" small class="mr-1"></b-spinner>
          Đồng bộ ảnh từ yêu cầu
        </b-button>

        <div class="d-flex">
          <b-button variant="secondary" class="mr-2" @click="closeModal"> Hủy </b-button>
          <b-button variant="primary" :disabled="!hasAnyFiles" @click="saveFiles">
            <b-spinner v-if="loading" small class="mr-1"></b-spinner>
            Lưu
          </b-button>
        </div>
      </div>
    </template>

    <!-- Cập nhật modal thông báo -->
    <b-modal id="modal-scoped" v-model="showModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" />
        <h2 class="f18 py-3">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer>
        <!-- Nếu có lỗi hoặc không thành công - chỉ hiển thị nút Đóng -->
        <b-button size="sm" variant="light" @click="closeModal"> Đóng </b-button>
      </template>
    </b-modal>
  </b-modal>
</template>

<script>
  import UploadMultipleCSKH from '@/components/cskh/UploadFIleOrImageMultip.vue'
  import { MerchantService } from '@/services/merchant.service'
  import { ComboService } from '@/services/combo.service'

  export default {
    name: 'UploadContractModal',
    components: {
      UploadMultipleCSKH,
    },
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
      type: {
        type: String,
        default: 'BUSINESSREG',
      },
      initialData: {
        type: Object,
        default: () => ({
          merchant: [],
          cccd: [],
          pdf: [],
          contract: [],
        }),
      },
      contractId: {
        type: String,
        required: true,
      },
      reqSellCode: {
        type: String,
        required: true,
      },
      customerId: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        isVisible: false,
        loading: false,
        loadingSync: false,
        showModal: false,
        uploadedFiles: {
          merchant: [],
          cccd: [],
          pdf: [],
          contract: [],
        },
        toasts: [],
        toastCounter: 0,
      }
    },
    computed: {
      hasAnyFiles() {
        return Object.values(this.uploadedFiles).some(files => files.length > 0)
      },
    },
    watch: {
      visible: {
        handler(newVal) {
          this.isVisible = newVal
        },
        immediate: true,
      },
      isVisible(newVal) {
        if (!newVal) {
          this.$emit('update:visible', false)
        }
      },
    },
    methods: {
      // Mở modal từ bên ngoài
      show() {
        this.$refs.uploadModal.show()
      },

      // Đóng modal
      hide() {
        this.$refs.uploadModal.hide()
      },

      handleModalShown() {
        this.loadInitialData()
        // this.$emit('shown')
      },

      handleModalHidden() {
        this.isVisible = false
        // this.$emit('hidden')
        this.$emit('update:visible', false)
      },

      loadInitialData() {
        this.$nextTick(() => {
          // Chuyển đổi format data để phù hợp với setData của UploadMultipleCSKH

          // Load ảnh Merchant
          if (this.initialData.merchant && this.initialData.merchant.length > 0) {
            const merchantData = this.initialData.merchant.map(item => ({
              url: item.dataURL,
              location: item.dataURL,
              type: 'merchant',
              uploaded: true,
              name: `Merchant - ${item.accessKey.substring(0, 8)}`,
              accessKey: item.accessKey,
              dataType: this.type || item.dataType,
            }))
            if (this.$refs.merchantUpload) this.$refs.merchantUpload.setData(merchantData)
            this.uploadedFiles.merchant = [...merchantData]
          }

          // Load ảnh CCCD
          if (this.initialData.cccd && this.initialData.cccd.length > 0) {
            const cccdData = this.initialData.cccd.map(item => ({
              url: item.dataURL,
              location: item.dataURL,
              type: 'cccd',
              uploaded: true,
              name: `CCCD - ${item.accessKey.substring(0, 8)}`,
              accessKey: item.accessKey,
              dataType: item.dataType,
            }))
            if (this.$refs.cccdUpload) this.$refs.cccdUpload.setData(cccdData)
            this.uploadedFiles.cccd = [...cccdData]
          }

          // Load file PDF
          if (this.initialData.pdf && this.initialData.pdf.length > 0) {
            const pdfData = this.initialData.pdf.map(item => ({
              url: item.dataURL,
              location: item.dataURL,
              type: 'pdf',
              uploaded: true,
              name: `PDF - ${item.accessKey.substring(0, 8)}.pdf`,
              accessKey: item.accessKey,
              dataType: item.dataType,
            }))
            if (this.$refs.pdfUpload) this.$refs.pdfUpload.setData(pdfData)
            this.uploadedFiles.pdf = [...pdfData]
          }

          // Load ảnh hợp đồng
          // if (this.initialData.contract && this.initialData.contract.length > 0) {
          //   const contractData = this.initialData.contract.map(item => ({
          //     url: item.dataURL,
          //     location: item.dataURL,
          //     type: 'contract',
          //     uploaded: true,
          //     name: `Contract - ${item.accessKey.substring(0, 8)}`,
          //     accessKey: item.accessKey,
          //     dataType: item.dataType
          //   }))
          //   this.$refs.contractUpload?.setData(contractData)
          //   this.uploadedFiles.contract = [...contractData]
          // }
        })
      },

      handleFileChange(type, files) {
        this.uploadedFiles[type] = [...files]
        this.showToast(`Đã cập nhật ${this.getTypeLabel(type)}`, 'success')
      },

      getTypeLabel(type) {
        const labels = {
          merchant: 'ảnh Merchant',
          cccd: 'ảnh CCCD',
          pdf: 'file PDF',
          contract: 'ảnh hợp đồng',
        }
        return labels[type] || type
      },

      async fetchDetailBySellCode() {
        try {
          const response = await ComboService.getList({
            keyword: this.reqSellCode,
          })
          if (response.code === 1000) {
            return response.data[0] || {}
          } else {
            return {}
          }
        } catch (error) {
          console.error('Error fetching data:', error)
          return {}
        }
      },
      // Thay thế method syncFromRequest
      async syncFromRequest() {
        this.loadingSync = true
        try {
          const detail = await this.fetchDetailBySellCode()

          if (!detail || Object.keys(detail).length === 0) {
            this.showToast('Không tìm thấy dữ liệu yêu cầu', 'warning')
            return
          }

          // Reset tất cả upload components
          if (this.$refs.merchantUpload) this.$refs.merchantUpload.setData([])
          if (this.$refs.cccdUpload) this.$refs.cccdUpload.setData([])
          if (this.$refs.pdfUpload) this.$refs.pdfUpload.setData([])
          // this.$refs.contractUpload?.setData([])

          // Reset local data
          this.uploadedFiles = {
            merchant: [],
            cccd: [],
            pdf: [],
            contract: [],
          }

          // Xử lý ảnh CCCD từ identityImages
          if (detail.identityImages && detail.identityImages.length > 0) {
            const cccdData = detail.identityImages.map((item, index) => ({
              url: item || '',
              location: 'Mnp',
              type: 'cccd',
              uploaded: true,
              name: `CCCD - ${index + 1}`,
              accessKey: item.accessKey,
              dataType: 'CMND',
            }))
            if (this.$refs.cccdUpload) this.$refs.cccdUpload.setData(cccdData)
            this.uploadedFiles.cccd = [...cccdData]
          }

          // Xử lý ảnh Merchant từ businessRegistrationNumberImages và contractImages
          const merchantData = []

          // Thêm ảnh ĐKKD
          if (
            detail.businessRegistrationNumberImages &&
            detail.businessRegistrationNumberImages.length > 0
          ) {
            const businessImages = detail.businessRegistrationNumberImages.map((item, index) => ({
              url: item || '',
              location: 'Mnp',
              type: 'merchant',
              uploaded: true,
              name: `ĐKKD - ${index + 1}`,
              accessKey: item.accessKey,
              dataType: this.type || 'BUSINESSREG',
            }))
            merchantData.push(...businessImages)
          }

          // Thêm ảnh mẫu đăng ký (contractImages)
          if (detail.contractImages && detail.contractImages.length > 0) {
            const contractImages = detail.contractImages.map((item, index) => ({
              url: item || '',
              location: 'Mnp',
              type: 'merchant',
              uploaded: true,
              name: `Mẫu đăng ký - ${index + 1}`,
              accessKey: item.accessKey,
              dataType: this.type || 'BUSINESSREG',
            }))
            merchantData.push(...contractImages)
          }

          if (merchantData.length > 0) {
            if (this.$refs.merchantUpload) this.$refs.merchantUpload.setData(merchantData)
            this.uploadedFiles.merchant = [...merchantData]
          }

          // Xử lý file PDF từ contractFiles
          if (detail.contractFiles && detail.contractFiles.length > 0) {
            const pdfData = detail.contractFiles.map((item, index) => ({
              url: item || '',
              location: 'Mnp',
              type: 'pdf',
              uploaded: true,
              name: `File mẫu đăng ký - ${index + 1}.pdf`,
              accessKey: item.accessKey,
              dataType: 'PDF',
            }))
            if (this.$refs.pdfUpload) this.$refs.pdfUpload.setData(pdfData)
            this.uploadedFiles.pdf = [...pdfData]
          }

          // this.showToast('Đã đồng bộ ảnh từ yêu cầu thành công', 'success')
        } catch (error) {
          console.error('Error syncing from request:', error)
          this.showToast('Lỗi khi đồng bộ ảnh từ yêu cầu', 'danger')
        } finally {
          this.loadingSync = false
        }
      },

      async saveFiles() {
        try {
          this.loading = true

          // Lấy dữ liệu từ tất cả upload components
          const merchantData = this.$refs.merchantUpload?.getData() || []
          const cccdData = this.$refs.cccdUpload?.getData() || []
          const pdfData = this.$refs.pdfUpload?.getData() || []
          const contractData = this.$refs.contractUpload?.getData() || []

          // Kiểm tra nếu có file chưa upload (file mới không có accessKey)
          const allFiles = [...merchantData, ...cccdData, ...pdfData, ...contractData]
          const unuploadedFiles = allFiles.filter(
            file => !file.uploaded && file.file && !file.accessKey
          )

          if (unuploadedFiles.length > 0) {
            // Upload các file mới chưa được upload
            const uploadPromises = []

            if (merchantData.some(f => !f.uploaded && !f.accessKey)) {
              uploadPromises.push(this.$refs.merchantUpload?.saveData())
            }
            if (cccdData.some(f => !f.uploaded && !f.accessKey)) {
              uploadPromises.push(this.$refs.cccdUpload?.saveData())
            }
            if (pdfData.some(f => !f.uploaded && !f.accessKey)) {
              uploadPromises.push(this.$refs.pdfUpload?.saveData())
            }
            // if (contractData.some(f => !f.uploaded && !f.accessKey)) {
            //   uploadPromises.push(this.$refs.contractUpload?.saveData())
            // }

            await Promise.all(uploadPromises)
          }

          // Lấy lại dữ liệu sau khi upload
          const finalMerchantData = this.$refs.merchantUpload?.getData() || []
          const finalCccdData = this.$refs.cccdUpload?.getData() || []
          const finalPdfData = this.$refs.pdfUpload?.getData() || []
          // const finalContractData = this.$refs.contractUpload?.getData() || []

          // Tạo mảng images cho API
          const images = []

          // Thêm PDF files (dataType: "PDF")
          finalPdfData.forEach(file => {
            if (file.url || file.s3Url) {
              const imageItem = {
                contractS3URL: file.url || file.s3Url,
                dataType: 'PDF',
              }

              // Nếu có accessKey thì đây là file cũ (cập nhật)
              if (file.accessKey) {
                imageItem.accessKey = file.accessKey
              }
              // Không có accessKey thì đây là file mới (tạo mới)

              images.push(imageItem)
            }
          })

          // Thêm CCCD images (dataType: "CMND")
          finalCccdData.forEach(file => {
            if (file.url || file.s3Url) {
              const imageItem = {
                contractS3URL: file.url || file.s3Url,
                dataType: 'CMND',
              }

              if (file.accessKey) {
                imageItem.accessKey = file.accessKey
              }

              images.push(imageItem)
            }
          })

          // Thêm Merchant images (dataType: "BUSINESSREG")
          finalMerchantData.forEach(file => {
            if (file.url || file.s3Url) {
              const imageItem = {
                contractS3URL: file.url || file.s3Url,
                dataType: this.type || 'BUSINESSREG',
              }

              if (file.accessKey) {
                imageItem.accessKey = file.accessKey
              }

              images.push(imageItem)
            }
          })

          // Thêm Contract images (dataType: "BILL")
          // finalContractData.forEach(file => {
          //   if (file.url || file.s3Url) {
          //     const imageItem = {
          //       contractS3URL: file.url || file.s3Url,
          //       dataType: "BILL"
          //     }

          //     if (file.accessKey) {
          //       imageItem.accessKey = file.accessKey
          //     }

          //     images.push(imageItem)
          //   }
          // })

          // Tạo body API
          const apiBody = {
            contractId: this.contractId,
            customerId: this.customerId,
            deviceType: 'WEB',
            images: images,
          }

          // Gọi API
          const response = await MerchantService.uploadContactImage(apiBody)

          if (response.code === 1000 || response.code === 70040) {
            // Emit event để parent component xử lý
            this.$emit('load')
            this.showModal = true
            this.iconNoti = require('@/assets/img/noti-success2.svg')
            this.msgNoti = 'Đã lưu thành công!'
          } else {
            this.showModal = true
            this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
            this.msgNoti = response.message || 'Lỗi khi lưu files'
          }
        } catch (error) {
          console.error('Lỗi khi lưu files:', error)
          this.showModal = true
          this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
          this.msgNoti = error.message || 'Lỗi khi lưu files'
        } finally {
          this.loading = false
        }
      },

      closeModal() {
        this.hide()
        this.showModal = false
      },

      showToast(message, variant = 'success', title = '') {
        const toastId = `toast-${++this.toastCounter}`
        const toast = {
          id: toastId,
          message,
          variant,
          title: title || this.getToastTitle(variant),
        }

        this.toasts.push(toast)

        this.$nextTick(() => {
          this.$bvToast.show(toastId)
        })

        // Remove toast from array after it's hidden
        setTimeout(() => {
          const index = this.toasts.findIndex(t => t.id === toastId)
          if (index > -1) {
            this.toasts.splice(index, 1)
          }
        }, 4000)
      },

      getToastTitle(variant) {
        const titles = {
          success: 'Thành công',
          danger: 'Lỗi',
          warning: 'Cảnh báo',
          info: 'Thông tin',
        }
        return titles[variant] || 'Thông báo'
      },
    },
  }
</script>

<style lang="scss" scoped>
  .upload-contract-content {
    .upload-section {
      margin-bottom: 25px;

      &:last-child {
        margin-bottom: 0;
      }

      :deep(.section-title) {
        font-size: 16px;
        font-weight: 600;
        color: #333;
        margin-bottom: 15px;
      }
    }
  }

  // Custom modal styles
  :deep(.modal-xl) {
    max-width: 1000px;
  }

  :deep(.modal-header) {
    background-color: #f8f9fa;
    border-bottom: 1px solid #dee2e6;

    .modal-title {
      font-weight: 600;
      color: #333;
    }
  }

  :deep(.modal-footer) {
    background-color: #f8f9fa;
    border-top: 1px solid #dee2e6;
    padding: 15px 20px;
  }

  :deep(.modal-body) {
    padding: 25px;
    max-height: 70vh;
    overflow-y: auto;
  }

  // Responsive styles
  @media (max-width: 768px) {
    :deep(.modal-xl) {
      max-width: 95%;
      margin: 10px auto;
    }

    :deep(.modal-body) {
      padding: 15px;
      max-height: 60vh;
    }

    :deep(.modal-footer) {
      padding: 10px 15px;

      .d-flex {
        flex-direction: column;
        width: 100%;

        &.justify-content-between {
          gap: 15px;
        }

        &:last-child {
          flex-direction: row;
          justify-content: center;
        }
      }
    }
  }
</style>
